/**
 * Which Beacon instance this bundle belongs to.
 *
 * The literals below are the shared Pritect project and are what source, tests
 * and a plain `pnpm build` see. rollup.config.mjs rewrites them at build time
 * from PB_API_URL, PB_ANON_KEY and PB_CDN_BASE, which
 * scripts/upload-consent-script.mjs sets from the project it is publishing to.
 * So a bundle published to a dedicated or self-hosted instance falls back to
 * that instance, never to the shared one.
 *
 * Kept in its own module, holding nothing else, so the build can substitute it
 * by path. Do not inline these values anywhere else in the bundle.
 */

/** Supabase project the engine talks to when the embed has no data-api-url. */
export const DEFAULT_API_URL = "https://ynbeopknlxoayzdocsmu.supabase.co";

/** Publishable key for DEFAULT_API_URL, used when the embed has no data-anon-key. */
export const DEFAULT_ANON_KEY = "sb_publishable_vU9Z7i0RWBnGJtu3p7_t5Q_JgZuhJBP";

/** Bucket root the loader fetches the core from when it cannot resolve its own URL. */
export const DEFAULT_CDN_BASE =
  "https://ynbeopknlxoayzdocsmu.supabase.co/storage/v1/object/public/consent-scripts";
